import { APP_BASE_URL } from "../../config/api";
import { authFetch } from "../../utils/api";
// Entity admin APIs now under /api/admin
const BASE_URL = `${APP_BASE_URL}/api/admin/entities`;

export async function listEntities() {
  console.log("🔍 API Call:", { method: "GET", url: BASE_URL });

  try {
    const res = await authFetch(BASE_URL);
    console.log("📥 Response Status:", res.status);

    if (!res.ok) {
      const errorText = await res.text();
      console.error("❌ Error:", {
        status: res.status,
        statusText: res.statusText,
        body: errorText,
      });
      throw new Error(
        `Failed to fetch entities: ${res.status} ${res.statusText}`,
      );
    }

    const data = await res.json();
    console.log("✅ Success:", data);
    return data;
  } catch (error) {
    console.error("🚨 Request Failed:", error.message);
    throw error;
  }
}

export async function createEntity(payload) {
  const res = await authFetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to create entity");
  return res.json();
}

export async function updateEntity(id, payload) {
  const res = await authFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to update entity");
  return res.json();
}

export async function deleteEntity(id) {
  const res = await authFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete entity");
}
